import ShopAll from './ShopAll';
import ShopAllContainer from './ShopAll.container';

export default ShopAllContainer(ShopAll);
